
import React from 'react';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from 'react-hook-form';

interface GynecologicalFieldProps {
  form: UseFormReturn<any>;
}

const GynecologicalField: React.FC<GynecologicalFieldProps> = ({ form }) => {
  const watchHadGynSurgery = form.watch("hadGynSurgery");

  return (
    <div className="space-y-4 border-b pb-4">
      <FormField
        control={form.control}
        name="hadGynSurgery"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-3">
            <div className="space-y-0.5">
              <FormLabel>Have you had any gynecological surgeries?</FormLabel>
              <FormDescription>
                Such as hysterectomy, ovarian surgery, or tubal ligation
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />

      {watchHadGynSurgery && (
        <FormField
          control={form.control}
          name="gynSurgeryDetails"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Please describe your gynecological surgeries</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Type of surgery and when it occurred"
                  className="resize-none"
                  {...field}
                  value={field.value || ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
};

export default GynecologicalField;
